import { createTheme } from '@mui/material/styles';

export const FAMILY_NAVY = '#1B2A4A';
export const FAMILY_CREAM = '#F7F1E8';
export const FAMILY_CORAL = '#E07A5F';
export const CHILD_COLORS = ['#C9A227', '#5B8E7D', '#6C63B0', '#E07A5F'];

export function childColor(studentId) {
  const s = String(studentId || '');
  let n = 0;
  for (let i = 0; i < s.length; i += 1) n = (n + s.charCodeAt(i)) % CHILD_COLORS.length;
  return CHILD_COLORS[n];
}

export const familyTheme = createTheme({
  palette: {
    primary: { main: FAMILY_CORAL, contrastText: '#fff' },
    secondary: { main: FAMILY_NAVY },
    background: { default: FAMILY_CREAM, paper: '#FFFcf7' },
    text: { primary: FAMILY_NAVY, secondary: '#5C6578' },
  },
  typography: {
    fontFamily: '"Inter", "Segoe UI", "Helvetica Neue", Arial, sans-serif',
    button: { textTransform: 'none', fontWeight: 600 },
    h4: { fontWeight: 650 },
    h5: { fontWeight: 650 },
    h6: { fontWeight: 650 },
  },
  shape: { borderRadius: 16 },
  components: {
    MuiButton: {
      styleOverrides: {
        root: { borderRadius: 999, paddingLeft: 20, paddingRight: 20, minHeight: 44 },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: { borderRadius: 20, boxShadow: 'none', border: '1px solid rgba(27,42,74,0.08)' },
      },
    },
  },
});
